export default "__VITE_ASSET__06ab4fdb__"